/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-question': {
    width: 34,
    height: 42,
    viewBox: '0 0 34 42',
    data: '<g transform="translate(1 1)" _fill="none" fill-rule="evenodd"><path pid="0" d="M0 9.288C.528 4.104 7.477 0 15.99 0 24.826 0 32 4.443 32 9.915c0 5.426-5.936 7.818-10.683 8.954-3.109.74-5.306 3.014-5.312 5.688L16 36" _stroke="#005BA5" stroke-width="2"/><circle pid="1" _fill="#005BA5" cx="16" cy="40" r="1"/></g>'
  }
})
